module.exports = __webpack_public_path__ + "static/media/UB_logotyp_cremevit_RGB.30152aef.png";